import { RadioInput } from "./Radio";
import {
  Group,
  Label,
  Wrapper,
  Item,
  Indicator,
  OptionDetails
} from "./Radio.styles";

// Export the main component
export { RadioInput };
export type { RadioInputProps } from "./Radio";

// Export namespaced components
export const Radio = {
  Input: RadioInput,
  Group,
  Label,
  Wrapper,
  Item,
  Indicator,
  OptionDetails
};
